import React, { Component } from 'react'
import { Button, Card, Col, List, Row, notification } from 'antd';
import Request from '../../request'
import moment from 'moment'
import ListDrawer from './list';
import ReceiptsView from '../../components/DocumentViews/receiptsView'
import { RightsWrapper } from '../../components/_utils/utils';
import FinanceClaim from '../finance/all/index';

import {
    FaMoneyCheckAlt,
    FaRegBuilding,
    FaUserCog,
    FaFileInvoiceDollar,
    FaRegMoneyBillAlt,
    FaFileInvoice,
    FaPlaneDeparture,
    FaHistory,
    FaUserSlash,
    FaUserTimes,
    FaUserCheck,
    FaUserClock
} from "react-icons/fa";

import ConsultancyIcon from '../../assets/icons/registration/ConsultancyIcon.png'
import RegistrationIcon from '../../assets/icons/registration/RegistrationIcon.png'
import OutstandingIcon from '../../assets/icons/registration/OutstandingIcon.png'
import { getUrlPushWrapper } from "../../routes";
import { connect } from "react-redux";
import {
    FaRupeeSign
} from "react-icons/fa";
import FinanceTaxesCount from '../../components/Dashboard/financeTaxesCount';

class FinanceConsultancy extends Component {
    constructor(props) {
        super(props)
        this.state = {
            coldCount: 0,
            outstandingAgreement: {
                total: 0,
                arr: []
            },
            drawer: false,
            drawerParam: {},
            todaySubmittedReceipts: [],
            showTPSCSubmittedButton: false,
            showTECSubmittedButton: false,
            showAccountPaymentDrawar: false,
            submitReceiptCount: {
                submittedCount: 0,
                approvedCount: 0
            },
            visaApprovedTodayCount: {
                total: 0
            },
            invoiceToBeGeneratedTodayCount: {
                total: 0
            },
            invoiceGeneratedTodayCount: {
                total: 0
            },
            totalTaxCount: {
                total: 0
            },
            totalCompaniesDetailsCount: {
                total: 0
            },
            totalInvoicesToDetailsCount: {
                total: 0
            },
            universityCommissionEntered: {
                total: 0
            },
            courseCommissionEntered: {
                total: 0
            },
            InvoiceWaitingForCommissionEntered: {
                total: 0
            },
            overdueInvoices: {
                total: 0
            },
            totalWithdrawStudents: {
                total: 0
            },
            totalWithdrawRequestSent: {
                total: 0
            },
            studentWithdrawRequestApproved: {
                total: 0
            },
            studentWithdrawRequestRejected: {
                total: 0
            }
        }
    }

    loadApi = async () => {
        Request.consultancyReceivedData({ atLevel: ['Registration Desk'] }).then(({ data: registrationConsultancyData, outstandingAgreement }) => {
            this.setState({
                consultancyReceivedData: registrationConsultancyData && registrationConsultancyData.consultancyData,
                outstandingConsultancy: registrationConsultancyData && registrationConsultancyData.outstandingConsultancy,
                totalOutstandingConsultancyCount: registrationConsultancyData && registrationConsultancyData.totalOutstandingConsultancyCount
            })
        })
    }

    async componentDidMount() {
        await this.loadApi();
    }

    approveTodayFees = async () => {
        let response = await Request.approveTodayFees({});
        if (response.success === true) {
            notification.success({
                message: response.msg,
            });
            this.loadApi();
        } else {
            notification.error({ message: "Try again" });
        }
    }

    viewAccountPaymentReceipt = () => {
        this.setState({
            showAccountPaymentDrawar: true
        })
    }

    closeDocument = () => {
        this.setState({ showAccountPaymentDrawar: false });
    }

    exportExcelTodaysReceipts = async () => {
        let response = await Request.exportTodaysPayments();
        if (!response.error) {
            window.location.href = response.url;
        }
    }

    render() {
        let { dispatch } = this.props

        const {
            visaApprovedTodayCount,
            invoiceToBeGeneratedTodayCount,
            invoiceGeneratedTodayCount,
            totalTaxCount,
            totalCompaniesDetailsCount,
            totalInvoicesToDetailsCount,
            universityCommissionEntered,
            courseCommissionEntered,
            overdueInvoices,
            totalWithdrawStudents,
            totalWithdrawRequestSent,
            studentWithdrawRequestApproved,
            studentWithdrawRequestRejected,
            showAccountPaymentDrawar
        } = this.state;

        const {
            monthAndWeak,
            consultancyReceivedData,
            outstandingConsultancy,
            totalOutstandingConsultancyCount,
            todaySubmittedReceipts,
            submitReceiptCount,
            drawer,
            drawerParam
        } = this.state;

        let todaysPaymentHtml = [];
        let totalPaidToday = 0;
        todaySubmittedReceipts.map((todayRegistrationsReceipt, index) => {
            totalPaidToday += parseFloat(todayRegistrationsReceipt.totalAmount);
            todaysPaymentHtml.push(
                <tr key={index}>
                    <td>{todayRegistrationsReceipt.amountType}</td>
                    <td>{todayRegistrationsReceipt.studentId}</td>
                    <td>{todayRegistrationsReceipt.studentName}</td>
                    <td>{todayRegistrationsReceipt.dob}</td>
                    <td>{todayRegistrationsReceipt.receiptNumber}</td>
                    <td><FaRupeeSign />{todayRegistrationsReceipt.totalAmount}</td>
                    <td>{todayRegistrationsReceipt.paymentType}</td>
                    <td>{todayRegistrationsReceipt.remarks}</td>
                    <td>{todayRegistrationsReceipt.submittedDate && todayRegistrationsReceipt.approvedDate ? 'Approved' : (todayRegistrationsReceipt.submittedDate ? 'Submitted' : 'Pending')}</td>
                </tr>
            )
        })
        let showApprovedButton = false;
        if (this.state.todaySubmittedReceipts && this.state.todaySubmittedReceipts.length === this.state.submitReceiptCount.submittedCount) {
            showApprovedButton = true;
        }
        if (this.state.todaySubmittedReceipts && this.state.todaySubmittedReceipts.length === this.state.submitReceiptCount.approvedCount) {
            showApprovedButton = false;
        }

        return (
            <div>
                <div className="site-card-wrapper">
                    {
                        showAccountPaymentDrawar ?
                            <ReceiptsView onClose={this.closeDocument} />
                            : null
                    }
                    <RightsWrapper myRight={"financeConsultancy.view"}>
                        <Row gutter={16}>
                            {
                                drawer && <ListDrawer
                                    param={drawerParam}
                                    onClose={() => {
                                        this.setState({ drawer: false })
                                    }} />
                            }
                            <Col span={8}>
                                <Card style={{ height: '182px' }}

                                    headStyle={{
                                        backgroundColor: '#2b208d',
                                        color: 'white',
                                        minHeight: '11px',
                                        fontSize: '15px'
                                    }}
                                    bodyStyle={{ padding: '4px' }}
                                    title={
                                        <span>
                                            <img src={ConsultancyIcon} alt="card" /> Consultancy Received
                                        </span>
                                    }>
                                    <List
                                        size="small"
                                        bordered={false}
                                        dataSource={consultancyReceivedData ? consultancyReceivedData : []}
                                        renderItem={val => (<List.Item>

                                            <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
                                                {val.date === moment().format('DD-MM-YYYY') ?
                                                    <div style={{ color: '#2b208d' }}>Today</div> :
                                                    <div>{val.date}</div>}
                                                {val.date === moment().format('DD-MM-YYYY') ?
                                                    <div style={{ paddingLeft: '30px', color: '#2b208d' }}>-</div> :
                                                    <div>-</div>}

                                                {val && val.count !== 0 ? <button onClick={() => {
                                                    dispatch(
                                                        getUrlPushWrapper('desk.registration', { registrationDate: val && val.date })
                                                    )
                                                }}>

                                                    <div style={{ color: '#2b208d' }}> {val.count}</div>
                                                </button> : <div>{val.count}</div>}

                                            </div>
                                        </List.Item>)
                                        }
                                    >
                                    </List>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Row>
                                    <Col>
                                        <div style={{ marginTop: '10px' }}>
                                            <div style={{
                                                padding: '10px',
                                                color: 'white',
                                                backgroundColor: '#e85c43',
                                                fontSize: '15px',
                                                fontWeight: '500'
                                            }}>Outstanding Consultancy
                                            </div>
                                            <div style={{
                                                padding: '14px',
                                                color: 'white',
                                                fontSize: '10px',
                                                backgroundColor: '#d94d33'
                                            }}>
                                                <span style={{ fontSize: '15px' }}>Total</span> (INR)<span
                                                    style={{
                                                        fontSize: '15px',
                                                        marginLeft: '5px'
                                                    }}>{outstandingConsultancy ? outstandingConsultancy : 0}</span>
                                                <span
                                                    style={{
                                                        fontSize: '15px',
                                                        marginLeft: '30px'
                                                    }}>Count : ({totalOutstandingConsultancyCount ? totalOutstandingConsultancyCount : 0})</span>
                                                <img src={OutstandingIcon} alt="card"
                                                    style={{ float: 'right', height: '22px', width: '22px' }} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={8}>
                                <Row>
                                    <Col>
                                        <Card title={<span><img src={RegistrationIcon} alt="card" /> Registrations</span>}
                                            bordered={false}
                                            headStyle={{
                                                backgroundColor: '#85cf4a',
                                                color: 'white',
                                                minHeight: '11px',
                                                fontSize: '15px'
                                            }}
                                            bodyStyle={{ padding: '8px', height: '46px' }}>
                                            <Row>
                                                <Col span={12} style={{ textAlign: 'center', borderRight: '1px solid #ededed' }}>
                                                    <div>Weekly</div>

                                                    <div><button onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('desk.registration', { dateFilterByWeekOrMonth: 'week' })
                                                        )

                                                    }}>{monthAndWeak ? monthAndWeak.weakCount : 0} </button></div>
                                                </Col>
                                                <Col style={{ textAlign: 'center' }}
                                                    span={12}>
                                                    <div>Monthly</div>

                                                    <div><button onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('desk.registration', { dateFilterByWeekOrMonth: 'month' })
                                                        )

                                                    }}> {monthAndWeak ? monthAndWeak.monthCount : 0}</button></div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </RightsWrapper>
                </div>

            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
    (FinanceConsultancy)
